module.exports = __webpack_public_path__ + "media/images/payment/visa-icon-ad6e81b04288dea88359b504f183500d.png";